// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/supporting-content-card/supporting-content-card.component.scss
// module id = 517
// module chunks = 0